import React from "react";
import ContentVideo from "../ContentVideo";
import SectionWrapper from "../SectionWrapper";

interface Props {
  primaryVideo: Queries.EventPageQuery["datoCmsEvent"]["primaryVideo"];
  uiLabelsContentVideo: Queries.EventPageQuery["datoCmsLabel"]["uiLabelsContentVideo"][0];
}

const EventPageSectionPrimaryVideo = ({
  primaryVideo,
  uiLabelsContentVideo,
}: Props) => {
  return (
    <SectionWrapper noBorder additionalWrapperClassName="lg:mt-16">
      <ContentVideo
        video={primaryVideo}
        uiLabelsContentVideo={uiLabelsContentVideo}
      />
    </SectionWrapper>
  );
};

export default EventPageSectionPrimaryVideo;
